import { render, staticRenderFns } from "./AssistantMessage.vue?vue&type=template&id=66ba3e04"
import script from "./AssistantMessage.vue?vue&type=script&lang=js"
export * from "./AssistantMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports